/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const MONTH_LIST = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const EXPIRING_TODAY_MESSAGE = 'Expiring today.';
export const EXPIRED_TODAY_MESSAGE = 'Expired today.';
export const EXPIRED_MESSAGE = 'Expired.';
export const EXPIRES_IN_DAYS_MESSAGE = 'Expires in {0} days on ';
export const HARNESS_FEATURE_FLAG = {
  dimentionV2: "featrel_plat_liam_LIAM6055",
  builtinPolicies: "featrel_plat_liam_LIAM6056",
  globalRoles: "featrel_plat_liam_LIAM6057",
  exportRoles: "featrel_plat_liam_LIAM6072",
  graviteeEnablement: "featrel_plat_liam_LIAM6734",
  location: 'featrel_plat_liam_LIAM6812',
  userGroup: 'featrel_plat_liam_LIAM7717',
  mfaEnablement: 'featrel_plat_liam_LIAM9838',
  mfaReset: 'featrel_plat_liam_LIAM9836',
  dimensionAttributeFF: 'featrel_plat_liam_LIAM10181',
  efsMachineFF: 'featrel_plat_liam_ES1154'
}
export const NATIVE_STORE_LABEL = 'Blue Yonder User Store';
export const DOMAIN_NAME = 'blueyonder';
export const RND_DOMAIN = 'dev';
export const CUSTOMER_DOMAIN = 'inc';
